import type { ReactNode } from 'react';
import { useBrand, useLogoUrl } from '@/lib/brand';
import { AuthFooter } from './AuthFooter';

interface AuthPageShellProps {
  children: ReactNode;
}

export function AuthPageShell({ children }: AuthPageShellProps) {
  const brand = useBrand();
  const logoUrl = useLogoUrl();

  return (
    <div className="flex h-screen flex-col bg-white font-[Inter,sans-serif] text-foreground">
      {/* Header */}
      <header className="flex shrink-0 w-full items-center justify-between px-6 py-3 bg-white/80 backdrop-blur-md border-b border-black/[0.04]">
        <div className="flex items-center gap-2">
          <img src={logoUrl} alt={brand} className="h-7 w-auto" />
          <span className="font-heading text-xl font-extrabold tracking-tighter text-foreground">{brand}</span>
        </div>
      </header>

      {/* Main */}
      <main className="relative flex flex-1 min-h-0 flex-col items-center justify-center overflow-auto px-4 py-6">
        <div className="knox-dot-grid pointer-events-none absolute inset-0 opacity-10" />
        <div className="knox-card-glass relative w-full max-w-[420px] p-6 sm:p-8">
          {children}
        </div>
      </main>

      <AuthFooter />
    </div>
  );
}
